import { Calendar, Tag, X } from 'lucide-react';
import { formatDateTime } from 'utils/dateFormatter';

const ViewServiceCatalogModal = (props) => {
  const { isViewModalOpen, setIsViewModalOpen, entry } = props;
  if (!isViewModalOpen || !entry) return null;

  return (
    <div className='fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4'>
      <div className='bg-card border border-border rounded-lg w-full max-w-4xl max-h-[90vh] overflow-y-auto custom-scrollbar'>
        {/* Header */}
        <div className='sticky top-0 bg-card border-b border-border px-6 py-4 flex items-center justify-between'>
          <h2 className='text-lg font-semibold'>Service Catalog Entry Details</h2>
          <button onClick={() => setIsViewModalOpen(false)} className='p-1 hover:bg-muted rounded-md transition-colors'>
            <X size={20} />
          </button>
        </div>

        {/* Content */}
        <div className='p-6 space-y-6'>
          {/* Media Section */}
          {entry.image && (
            <div className='space-y-2'>
              <label className='text-xs font-medium text-muted-foreground uppercase'>Image</label>
              <img src={entry.image} alt='Service catalog entry' className='w-full h-32 object-cover rounded-lg border border-border' />
            </div>
          )}

          {/* Main Category */}
          {entry.mainCategory && (
            <div className='bg-blue-500/10 border border-blue-500/20 rounded-lg p-4'>
              <label className='text-xs font-medium text-muted-foreground uppercase block mb-2'>Main Category</label>
              <div className='text-sm font-semibold text-blue-600 dark:text-blue-400'>{entry.mainCategory.name?.english}</div>
              <div className='text-xs text-muted-foreground'>{entry.mainCategory.slug}</div>
            </div>
          )}

          {/* Sub Category */}
          {entry.subCategory && (
            <div className='bg-blue-500/10 border border-blue-500/20 rounded-lg p-4'>
              <label className='text-xs font-medium text-muted-foreground uppercase block mb-2'>Sub Category</label>
              <div className='text-sm font-semibold text-blue-600 dark:text-blue-400'>{entry.subCategory.name?.english}</div>
              <div className='text-xs text-muted-foreground'>{entry.subCategory.slug}</div>
            </div>
          )}

          {/* Basic Info */}
          <div className='space-y-1'>
            <label className='text-xs font-medium text-muted-foreground uppercase flex items-center space-x-1'>
              <Tag size={14} /><span>Name</span>
            </label>
            <p className='text-sm font-medium'>{entry.name || 'N/A'}</p>
          </div>

          {/* Description */}
          {entry.description && (
            <div className='space-y-2'>
              <label className='text-xs font-medium text-muted-foreground uppercase'>Description</label>
              <div className='bg-muted rounded-lg p-4'>
                <p className='text-sm'>{entry.description}</p>
              </div>
            </div>
          )}

          {/* Status */}
          <div className='space-y-1'>
            <label className='text-xs font-medium text-muted-foreground uppercase'>Status</label>
            <p>
              <span
                className={`px-2 py-1 rounded-md text-xs font-medium ${
                  entry.status === 'active'
                    ? 'bg-green-500/10 text-green-600 dark:text-green-400'
                    : 'bg-gray-500/10 text-gray-600 dark:text-gray-400'
                }`}
              >
                {entry.status === 'active' ? 'Active' : 'Inactive'}
              </span>
            </p>
          </div>

          {/* Timestamps */}
          <div className='grid grid-cols-1 md:grid-cols-2 gap-4 pt-4 border-t border-border'>
            <div className='space-y-1'>
              <label className='text-xs font-medium text-muted-foreground uppercase flex items-center space-x-1'>
                <Calendar size={14} /><span>Created At</span>
              </label>
              <p className='text-sm'>{formatDateTime(entry.createdAt)}</p>
            </div>
            <div className='space-y-1'>
              <label className='text-xs font-medium text-muted-foreground uppercase flex items-center space-x-1'>
                <Calendar size={14} /><span>Updated At</span>
              </label>
              <p className='text-sm'>{formatDateTime(entry.updatedAt)}</p>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className='flex justify-end px-6 py-4 border-t border-border'>
          <button onClick={() => setIsViewModalOpen(false)} className='px-4 py-2 text-sm border border-border rounded-md hover:bg-accent transition-colors'>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewServiceCatalogModal;
